import { useEffect, useMemo, useRef } from "react";

export const useOnResize = <Element extends HTMLElement>(
  onResize: (el: ResizeObserverEntry) => void,
) => {
  const callbackRef = useRef<(el: ResizeObserverEntry) => void>(null);
  const obsRef = useRef<ResizeObserver | null>(
    "ResizeObserver" in global
      ? new ResizeObserver((entries) => {
          if (entries[0]) {
            callbackRef.current?.(entries[0]);
          }
        })
      : null,
  );
  callbackRef.current = onResize;

  useEffect(
    () => () => {
      if (obsRef.current) {
        obsRef.current.disconnect();
        obsRef.current = null;
      }
    },
    [],
  );

  return useMemo(() => {
    let current: Element | null;
    return (instance: Element | null) => {
      if (current) {
        obsRef.current?.unobserve(current);
      }
      if (instance && instance !== current) {
        obsRef.current?.observe(instance);
      }
      current = instance;
    };
  }, []);
};
